import { BaseLayout } from '~/src/components/shared/layout'
import { FestivalContextProvider } from '~/src/contexts'
import { FestivalNavigation, FestivalNotice } from '~/src/components/festival'

export default function NoticePage() {

  return (
    <BaseLayout>
      <FestivalContextProvider>
        <FestivalNavigation />	
        <FestivalNotice />
      </FestivalContextProvider>
    </BaseLayout>
  )
}